if (!customElements.get('wlsn-clarity-buybox')) {
    class WLSNClarityBuybox extends HTMLElement {
        constructor() {
            super();
            this.selectors = {
                slides: '.js-wlsn-clarity-buybox-slides',
                thumbs: '.js-wlsn-clarity-buybox-thumbs',
                pagination: '.js-wlsn-clarity-buybox-pagination',
                prev: '.js-wlsn-slider-prev',
                next: '.js-wlsn-slider-next',
                purchase: '.js-wlsn-clarity-buybox-purchase',
                quantity: '.js-wlsn-clarity-buybox-quantity',
                decrease: '.js-wlsn-clarity-buybox-decrease',
                increase: '.js-wlsn-clarity-buybox-increase',
                atc: '.js-wlsn-clarity-buybox-atc',
            };
            this.onDecrease = this.onDecrease.bind(this);
            this.onIncrease = this.onIncrease.bind(this);
            this.onAddToCart = this.onAddToCart.bind(this);
        }

        connectedCallback() {
            this.quantityInput = this.querySelector(this.selectors.quantity);
            this.decreaseButton = this.querySelector(this.selectors.decrease);
            this.increaseButton = this.querySelector(this.selectors.increase);
            this.addToCartButton = this.querySelector(this.selectors.atc);
            this.drawer = document.querySelector('wlsn-cart-drawer');

            this.decreaseButton?.addEventListener('click', this.onDecrease);
            this.increaseButton?.addEventListener('click', this.onIncrease);
            this.addToCartButton?.addEventListener('click', this.onAddToCart);

            this.initializeSwiper();
        }

        disconnectedCallback() {
            this.decreaseButton?.removeEventListener('click', this.onDecrease);
            this.increaseButton?.removeEventListener('click', this.onIncrease);
            this.addToCartButton?.removeEventListener('click', this.onAddToCart);
            this.swiper?.destroy();
            this.thumbs?.destroy();
        }

        initializeSwiper() {
            if (typeof Swiper === 'undefined') {
                window.addEventListener('load', () => this.initializeSwiper(), { once: true });
                return;
            }

            const slidesElement = this.querySelector(this.selectors.slides);
            if (!slidesElement) return;

            const thumbsElement = this.querySelector(this.selectors.thumbs);

            if (thumbsElement) {
                this.thumbs = new Swiper(thumbsElement, {
                    spaceBetween: 8,
                    slidesPerView: 'auto',
                    watchSlidesProgress: true,
                    on: {
                        init: (swiper) => this.updateThumbsFit(swiper),
                        resize: (swiper) => this.updateThumbsFit(swiper),
                        lock: (swiper) => this.updateThumbsFit(swiper),
                        unlock: (swiper) => this.updateThumbsFit(swiper),
                    },
                });
            }

            this.swiper = new Swiper(slidesElement, {
                slidesPerView: 1,
                spaceBetween: 10,
                watchSlidesProgress: true,
                navigation: {
                    prevEl: this.querySelector(this.selectors.prev),
                    nextEl: this.querySelector(this.selectors.next),
                },
                pagination: {
                    el: this.querySelector(this.selectors.pagination),
                    type: 'bullets',
                    clickable: true,
                    enabled: true,
                },
                thumbs: this.thumbs ? { swiper: this.thumbs } : undefined,
                breakpoints: {
                    1024: {
                        pagination: { enabled: false },
                    },
                },
            });
        }

        /**
         * Centre the thumbs only while they all fit. Once they overflow, a centred
         * flex row would push the leading thumbs out of reach of Swiper's transform.
         */
        updateThumbsFit(swiper) {
            swiper?.el?.classList.toggle('is-thumbs-fit', swiper.isLocked);
        }

        onDecrease() {
            this.setQuantity((parseInt(this.quantityInput?.value, 10) || 1) - 1);
        }

        onIncrease() {
            this.setQuantity((parseInt(this.quantityInput?.value, 10) || 1) + 1);
        }

        setQuantity(quantity) {
            if (this.quantityInput) this.quantityInput.value = Math.max(1, quantity);
        }

        async onAddToCart(event) {
            event.preventDefault();
            if (this.addToCartButton.disabled) return;

            const variantId = Number(this.addToCartButton.dataset.variantId);
            if (!variantId) return;

            const payload = {
                id: variantId,
                quantity: parseInt(this.quantityInput?.value, 10) || 1,
            };
            const sellingPlan = this.querySelector(`${this.selectors.purchase}:checked`)?.value;
            if (sellingPlan) payload.selling_plan = Number(sellingPlan);

            this.addToCartButton.disabled = true;
            this.classList.add('is-loading');

            try {
                const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(payload),
                });

                if (!response.ok) throw new Error(await response.text());

                if (window.cartType === 'cart_drawer' && this.drawer) {
                    this.drawer.openDrawer();
                    this.drawer.setLoading(true);
                    await this.drawer.ensureHydrated();
                    await this.drawer.refreshDrawer();
                } else {
                    window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
                }
            } catch (error) {
                console.error('Clarity buybox add to cart failed.', error);
            } finally {
                this.classList.remove('is-loading');
                this.addToCartButton.disabled = false;
            }
        }
    }

    customElements.define('wlsn-clarity-buybox', WLSNClarityBuybox);
}
